// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class EventService {
   channels: any
   $http: angular.IHttpService
   endpoint: string
   
   constructor($http: any) {
      this.subscribe = this.subscribe.bind(this)
      this.publish = this.publish.bind(this)
      this.channels = {}
      this.$http = $http
      this.endpoint = "/api/usage/"
   }

   subscribe(channel: any, type: any, subscriber: any) {
      if (!this.channels[channel]) { this.channels[channel] = {} }
      if (!this.channels[channel][type]) { this.channels[channel][type] = [] }
      return this.channels[channel][type].push(subscriber)
   }

   publish(channel: any, type: any, data = {}) {
      let types
      if (types = this.channels[channel]) {
         let subs
         if (subs = types["*"]) {
            subs.forEach((sub: any) => sub(channel, type, data))
         }
         if (subs = types[type]) {
            return subs.forEach((sub: any) => sub(channel, type, data))
         }
      }
   }

   trackUsage(type: string, options: any) {
      if (type === 'wos') {
         this.$http.post(`${this.endpoint}${type}`, options)
      }
   }

   gaPush(category: any, action: any, label: any, value = null, nonInteraction = null) {
      (window as any).dataLayer = (window as any).dataLayer || []

      // Compute GA4-style event name, used for both dataLayer and gtag() paths
      const ga4EventName = category === 'search'
         ? 'search'
         : `${category}_${action}`.replace(/[\s-]+/g, '_').toLowerCase()

      if (category === 'search') {
         // 'search': event name is same in legacy and GA4 format.
         // Single merged push avoids double-counting while including GA4 parameters.
         (window as any).dataLayer.push({
            event: 'search',
            search_term: label,
            search_type: action,
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value,
            eventNonInteraction: nonInteraction
         });
      } else {
         // Event names differ (e.g. category='sort', ga4EventName='sort_results').
         // Legacy push preserves existing GTM trigger configurations.
         (window as any).dataLayer.push({
            event: category,
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value,
            eventNonInteraction: nonInteraction
         });
         // GA4-style push for new GTM setups using a GA4 Event tag with event name = {{Event}}.
         // New GTM clients should create triggers matching these GA4 event names:
         // sort_results, refinements_add, refinements_remove, refinements_clear,
         // saved_search_saved, saved_search_removed, saved_search_run
         (window as any).dataLayer.push({
            event: ga4EventName,
            event_label: label,
            value: value
         });
      }

      // Legacy Universal Analytics (UA- codes)
      // @ts-ignore FIXME global _gaq
      if (typeof _gaq !== 'undefined' && _gaq !== null) {
         // @ts-ignore FIXME global _gaq
         _gaq.push(['_trackEvent', category, action, label, value, nonInteraction])

         // push a pageview tracker object w/virtual path '/search' so that search terms can be tracked in GA Site Search - SUM-65044
         if ((category === 'search') && ['new', 'advanced'].includes(action)) {
            // @ts-ignore FIXME global _gaq
            _gaq.push(['_trackPageview', `/search?term=${label}`])
         }
      }

      // GA4 direct (G- codes) - gtag() is only defined when a G- tracking code is configured in index.erb
      // Note: gtag() itself pushes to dataLayer internally, but GA4 ignores raw dataLayer.push() calls,
      // so there is no double-counting with the dataLayer push above.
      // @ts-ignore FIXME global gtag
      if (typeof gtag !== 'undefined' && gtag !== null) {
         if (category === 'search') {
            // Use GA4 recommended 'search' event with search_term parameter
            // @ts-ignore FIXME global gtag
            gtag('event', 'search', { search_term: label, search_type: action })
         } else {
            // @ts-ignore FIXME global gtag
            gtag('event', ga4EventName, { event_label: label, value: value })
         }
      }
   }
}

angular.module('summonApp.services')
   .service('eventService', ['$http', EventService])
